export enum SearchResultsBanner {
  SIGN_UP_PRODUCT_GRID_BANNER,
}
